import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminSupportStepRulesetsComponent } from './admin-support-step-rulesets.component';

const routes: Routes = [
  {
    path: '',
    component: AdminSupportStepRulesetsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminSupportStepRulesetsRoutingModule {}
